var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmprestimosNaoSelecionados({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#8E58BF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 19V13M18 13L15 16M18 13L21 16M24 8H25C25.2652 8 25.5196 8.10536 25.7071 8.29289C25.8946 8.48043 26 8.73478 26 9V27C26 27.2652 25.8946 27.5196 25.7071 27.7071C25.5196 27.8946 25.2652 28 25 28H12.5C11.837 28 11.2011 27.7366 10.7322 27.2678C10.2634 26.7989 10 26.163 10 25.5M10 25.5C10 24.837 10.2634 24.2011 10.7322 23.7322C11.2011 23.2634 11.837 23 12.5 23H26M10 25.5V10.5C10 9.83696 10.2634 9.20107 10.7322 8.73223C11.2011 8.26339 11.837 8 12.5 8M15 11L18 8L21 11",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmprestimosNaoSelecionados);
export default __webpack_public_path__ + "static/media/iconEmprestimosNaoSelecionados.eaed866f61cde66505238579b11179a0.svg";
export { ForwardRef as ReactComponent };